export default __webpack_public_path__ + "static/media/flightgift_logos.54d07b89.png";